import Axios from "axios";

export type ResendVisitorConsentLinkType = "visitor" | "admin";

export type IssuedVisitorConsentTokenResponse = {
  placeBookingId?: number;
  noPlaceZoneBookingVisitorRegistrationId?: number;
  linkType: ResendVisitorConsentLinkType;
  rawToken: string;
  consentUrl: string;
  expiresAt: string;
};

export const resendVisitorConsentLinkForPlaceBooking = (
  placeBookingId: number,
  linkType: ResendVisitorConsentLinkType = "visitor"
) =>
  Axios.post<IssuedVisitorConsentTokenResponse>(
    `/visit/consent-tokens/place-bookings/${encodeURIComponent(String(placeBookingId))}/resend`,
    { linkType }
  );

export const resendVisitorConsentLinkForVisitorRegistration = (
  visitorRegistrationId: number,
  linkType: ResendVisitorConsentLinkType = "visitor"
) =>
  Axios.post<IssuedVisitorConsentTokenResponse>(
    `/visit/consent-tokens/visitor-registrations/${encodeURIComponent(String(visitorRegistrationId))}/resend`,
    { linkType }
  );
